import { createSlice } from "@reduxjs/toolkit";

// Load saved user (includes token now)
const savedUser = sessionStorage.getItem("user")
    ? JSON.parse(sessionStorage.getItem("user"))
    : null;

const authSlice = createSlice({
    name: "auth",
    initialState: {
        isLoggedIn: savedUser ? true : false,
        user: savedUser,    // includes token
    },
    reducers: {
        loginSuccess: (state, action) => {
            state.isLoggedIn = true;
            state.user = action.payload.user;   // 🔥 user already contains token

            sessionStorage.setItem("user", JSON.stringify(action.payload.user));
        },

        logout: (state) => {
            state.isLoggedIn = false;
            state.user = null;
            sessionStorage.clear();
        }
    }
});


export const { loginSuccess, logout } = authSlice.actions;
export default authSlice.reducer;
